import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import React from 'react';

const useStyles = makeStyles()(() => ({
  titleLogin: {
    display: 'flex',
    flexDirection: 'column-reverse',
    flexGrow: 1,
  },
  link: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: '10px',
    width: '100%',
    left: 0,
    '& a': {
      fontSize: '13px',
      lineHeight: '22px',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      textDecoration: 'none',
      color: '#A568F3',
      marginLeft: '20px',
    },
  },
  info: {
    margin: 0,
  }
}));

export const LoginFooter: React.VFC<{ isAutoSignOut: boolean }> = ({ isAutoSignOut }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  if (isAutoSignOut) {
    return null;
  }

  return (
    <Box className={classes.link}>
      <p className={classes.info}>{l10n.auth.newToUplift}</p>
      <a href="https://www.joinuplift.co/" rel="noreferrer" target="_blank">
        {l10n.navigation.learnMore}
      </a>
    </Box>
  );
};
